import {
  EventRegistration,
  EventRegistrationDTO,
} from "Types/Admin/AdminEventRegistrationType";
import { ResultsDTO } from "Types/ResultsDTO";
import { ApiService } from "./ApiService";

export const EventRegistrationApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    createEventRegistration: builder.mutation<ResultsDTO, EventRegistrationDTO>({
      query: (data) => ({
        url: "/eventRegistration/save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["EventRegistration"],
    }),

    getAllEventRegistrations: builder.query<EventRegistration[], { plant: string }>({
      query: ({ plant }) => ({
        url: "/eventRegistration/getAll",
        method: "GET",
        params: { plant },
      }),
      transformResponse: (response: ResultsDTO<any[]>) => {
        const list = response.results ?? [];
        return list.map((r: any) => ({
          id: r.id,
          eventHdrId: r.eventHdrId,
          firstName: r.firstName,
          lastName: r.lastName,
          email: r.email,
          contactNumber: r.contactNumber,
          address: r.address,
          city: r.city,
          state: r.state,
          country: r.country,
          pin: r.pin,
          plant: r.plant,
          createdAt: r.crAt,
          updatedAt: r.modAt,
        }));
      },
      providesTags: ["EventRegistration"],
    }),

    getEventRegistrationById: builder.query<EventRegistration, { id: number; plant: string }>({
      query: ({ id, plant }) => ({
        url: "/eventRegistration",
        method: "GET",
        params: { id, plant },
      }),
      transformResponse: (response: ResultsDTO<any>) => {
        const r = response.results ?? {};
        return {
          id: r.id,
          eventHdrId: r.eventHdrId,
          firstName: r.firstName,
          lastName: r.lastName,
          email: r.email,
          contactNumber: r.contactNumber,
          address: r.address,
          city: r.city,
          state: r.state,
          country: r.country,
          pin: r.pin,
          plant: r.plant,
          createdAt: r.crAt,
          updatedAt: r.modAt,
        };
      },
      providesTags: (r, e, a) => [{ type: "EventRegistration", id: a.id }],
    }),

    updateEventRegistration: builder.mutation<ResultsDTO, EventRegistrationDTO>({
      query: (data) => ({
        url: "/eventRegistration/update",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["EventRegistration"],
    }),

    deleteEventRegistration: builder.mutation<ResultsDTO, { id: number; plant: string }>({
      query: ({ id, plant }) => ({
        url: "/eventRegistration/delete",
        method: "DELETE",
        params: { id, plant },
      }),
      invalidatesTags: ["EventRegistration"],
    }),
  }),
});

export const {
  useCreateEventRegistrationMutation,
  useGetAllEventRegistrationsQuery,
  useGetEventRegistrationByIdQuery,
  useUpdateEventRegistrationMutation,
  useDeleteEventRegistrationMutation,
  useLazyGetEventRegistrationByIdQuery,
  useLazyGetAllEventRegistrationsQuery,
} = EventRegistrationApiSlice;
